// services/calendar.ts
import api from './api';

export const calendarService = {
  // 営業日チェック
  async isWorkingDay(date: string): Promise<boolean> {
    try {
      const response = await api.get(`/calendar/check-working-day/${date}`);
      return response.data.isWorkingDay;
    } catch (error) {
      console.error('Error checking working day:', error);
      return false;
    }
  },

  // 期間内の稼働日を取得
  async getWorkingDaysInRange(startDate: string, endDate: string): Promise<{ success: boolean; workingDays: string[] }> {
    try {
      const response = await api.get(`/calendar/working-days`, {
        params: { startDate, endDate }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching working days:', error);
      return { success: false, workingDays: [] };
    }
  }
};